import "./index.scss";

export const CarouselSlide = ({
  cta,
  linkTo,
  imageDesktop,
  imageTablet,
  imageMobile
}) => {
  return (
    <a className="carousel-slide" href={linkTo}>
      <picture>
        <source srcSet={imageDesktop} media="(min-width: 1150px)" />
        <source srcSet={imageTablet} media="(min-width: 768px)" />
        <source srcSet={imageMobile} />
        <img src={imageMobile} alt={cta} height={300} width={600} />
      </picture>
    </a>
  );
};
